import { Inject, Injectable, Optional } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { LAZY_MAPS_API_CONFIG } from '@agm/core';

@Injectable({
  providedIn: 'root'
})
export class GeocodingService {
  constructor(@Optional() @Inject(LAZY_MAPS_API_CONFIG) private agmConfig: any, private http: HttpClient) { }

  getCurrentLocation(): Promise<any> {
    return new Promise((resolve, reject) => {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          (position) => resolve(position),
          (error) => {
            // Handle and print error based on error.code
            switch (error.code) {
              case error.PERMISSION_DENIED:
                console.error('User location access is denied. Need to enable the location permission');
                // window.alert('User location access is denied. Need to enable the location permission')
                break;
              case error.POSITION_UNAVAILABLE:
                console.error('Location information is unavailable.');
                break;
              case error.TIMEOUT:
                console.error('The request to get user location timed out.');
                break;
              default:
                console.error('Geolocation error:', error.message);
                break;
            }
            reject(error);
          }
        );
      } else {
        console.error('Geolocation is not supported by this browser.');
        reject(new Error('Geolocation is not supported by this browser.'));
      }
    });
  }

  loadGoogleMapsScript(): Promise<any> {
    return new Promise((resolve, reject) => {
      if (typeof google !== 'undefined' && google.maps) {
        resolve(google);
        return;
      }

      const scriptId = 'google-maps-api-script';
      let script = document.getElementById(scriptId) as HTMLScriptElement;
      if (script) {
        script.addEventListener('load', () => resolve(google));
        script.addEventListener('error', (err) => reject(err));
        return;
      }

      script = document.createElement('script');
      script.id = scriptId;
      const apiKey = this.agmConfig?.apiKey || '';
      script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=places,geometry,marker`;
      script.async = true;
      script.defer = true;
      script.onload = () => {
        resolve(google);
      };
      script.onerror = (err) => {
        reject(err);
      };
      document.body.appendChild(script);
    });
  }
}
